/* eslint-disable react/prop-types */
import React from "react";
import { useNavigate } from "react-router-dom";
import { FiCheck } from "react-icons/fi";

/**
 * Step four: what actually landed.
 *
 * The backend drops lines it can't ground to eVital or that have no inventory,
 * and returns only a quotation id. Reading the quotation back and naming the
 * missing lines is the difference between a pharmacist finding out here and
 * finding out from the customer.
 */
const QuoteStep = ({ quotationId, sentLines, reconciliation, patientName, onStartAnother }) => {
    const navigate = useNavigate();
    const dropped = reconciliation?.dropped || [];

    return (
        <div className="mx-auto w-full max-w-xl">
            <div className="rounded-2xl border border-cod-gray-100 bg-white-50 p-8 text-center">
                <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-elm-50 text-elm-600">
                    <FiCheck size={20} />
                </span>

                <p className="mt-5 text-[11px] font-semibold uppercase tracking-[0.12em] text-cod-gray-400">
                    Quotation created
                </p>
                <p className="mt-2 text-4xl font-semibold tabular-nums tracking-tight text-cod-gray-900">
                    {quotationId}
                </p>
                <p className="mt-2 text-sm text-cod-gray-400">
                    For {patientName} · {reconciliation?.unknown ? sentLines.length : reconciliation.landed.length}{" "}
                    {(reconciliation?.unknown ? sentLines.length : reconciliation.landed.length) === 1 ? "medicine" : "medicines"}
                </p>

                <div className="mt-7 flex flex-col gap-2 sm:flex-row">
                    <button
                        type="button"
                        onClick={() => navigate(`/quotation/edit/${quotationId}`)}
                        className="flex-1 rounded-xl bg-cod-gray-900 py-3 text-sm font-semibold text-white-50 transition-colors hover:bg-cod-gray-800"
                    >
                        Open quotation
                    </button>
                    <button
                        type="button"
                        onClick={onStartAnother}
                        className="flex-1 rounded-xl border border-cod-gray-200 py-3 text-sm font-semibold text-cod-gray-900 transition-colors hover:bg-cod-gray-50"
                    >
                        Create another
                    </button>
                </div>
            </div>

            {dropped.length > 0 && (
                <div className="mt-4 rounded-xl border border-amber-200 bg-amber-50 p-5">
                    <p className="text-sm font-semibold text-amber-900">
                        {dropped.length} {dropped.length === 1 ? "medicine" : "medicines"} didn&apos;t make it in
                    </p>
                    <p className="mt-1 text-xs text-amber-700">
                        These have no matching stock in eVital. Add them by hand if the patient still needs them.
                    </p>
                    <ul className="mt-3 flex flex-col gap-1.5">
                        {dropped.map((line) => (
                            <li key={line.id} className="text-sm text-amber-900">
                                {line.name}
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {reconciliation?.unknown && (
                <p className="mt-4 text-center text-xs text-cod-gray-400">
                    Couldn&apos;t read the quotation back to confirm its lines. Open it to check what it holds.
                </p>
            )}
        </div>
    );
};

export default QuoteStep;
